import React, { useEffect } from "react";
// import test_ipynb from "../../static/nb_test.json"
import WorkflowComp from "./Workflow";
import WorkflowProvider from "./WorkflowContext/WorkflowContext";
const Workflow = () => {
    const workflowName = "openai_annotation"
    const [workflowData, setworkflowData] = React.useState({})
    const [isloading, setIsloading] = React.useState(false);
    const fetchWorkflow = async (workflowName) => {
        setIsloading(true);
        try {
            const url = "https://workable-ai-ml-3.onrender.com/get-workflow";
            const payload = {
                "name": workflowName,
                "secret": "abcdefgh567635@#%!&",
            }
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                console.error("Some error occured");
                console.error(response);
            } else {
                const data = await response.json();
                setworkflowData(data);
            }
            // const data = {
            //     "code": {
            //         "cells": [
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "yKjQKYAVOmI-"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "!pip install -q openai==1.11.0 # -q stands for quiet\n",
            //                     "!pip install -q pandas==2.2.0\n",
            //                     "!pip install -q timeout-decorator==0.5.0"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "1_20Klc2QWS2"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "import pandas as pd\n",
            //                     "from openai import OpenAI\n",
            //                     "from timeout_decorator import timeout\n",
            //                     "import time\n",
            //                     "from tqdm import tqdm\n",
            //                     "tqdm.pandas()"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {},
            //                 "outputs": [],
            //                 "source": [
            //                     "input_data_path = \"input_data.csv\"\n",
            //                     "# Name of the file to save the annotated data\n",
            //                     "annotated_data_path = f\"{input_data_path[:-4]}_annotated.csv\" \n",
            //                     "df = pd.read_csv(input_data_path)\n",
            //                     "df.head()"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {},
            //                 "outputs": [],
            //                 "source": [
            //                     "# specify list of columns to be used for annotation (basically the input to be given to chat-gpt)\n",
            //                     "columns_annotation = [] #[\"col1\", \"col2\"]\n",
            //                     "\n",
            //                     "# column to save the annotation output\n",
            //                     "output_annotation_column = \"\" \n",
            //                     "\n",
            //                     "# openai api hyper-parameters\n",
            //                     "# instructions that gpt model must follow while annotating each user input\n",
            //                     "openai_model = \"gpt-4\"\n",
            //                     "system_prompt = \"\"\"You are a helpful assistant.\"\"\"  # system prompt to be used for openai api, replace with your own prompt\n",
            //                     "\n",
            //                     "openai_api_key = \"##################\" # replace with your openai api key"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "oUCWU8RmS3cL"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "# Advanced Hyperaparameters\n",
            //                     "\n",
            //                     "openai_api_type = \"chat\" # either chat or complete refer https://platform.openai.com/playground\n",
            //                     "openai_api_timeout = 5 # in seconds (sometimes while running openai api multiple times it gets stuck without giving an exception hence using\n",
            //                     "                       # timeout decorator with specified timeout)\n",
            //                     "\n",
            //                     "temperature = 0\n",
            //                     "max_tokens = 512\n",
            //                     "top_p = 1\n",
            //                     "frequency_penalty = 0\n",
            //                     "presence_penalty = 0"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "_7jaBZ9OU30A"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "openai_client = OpenAI(api_key=openai_api_key)"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "Tap_WqD8fHgC"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "# create a merged column which contains all the information from columns_annotation to be used as the input to openai API\n",
            //                     "df[\"merged\"] = df[columns_annotation].apply(lambda row: \"\\n\".join(f\"{col}: {row[col]}\" for col in columns_annotation), axis=1)"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "colab": {
            //                         "base_uri": "https://localhost:8080/",
            //                         "height": 206
            //                     },
            //                     "id": "Jf3Kv5pyf2SM",
            //                     "outputId": "e755f64a-7253-43d5-c32f-717964db11ed"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "df.head()"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "imvpBDJbVgjc"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "@timeout(5, use_signals=False)\n",
            //                     "def get_openai_response(user_input):\n",
            //                     "    if openai_api_type == \"chat\":\n",
            //                     "\n",
            //                     "      response = openai_client.chat.completions.create(\n",
            //                     "        model = openai_model,\n",
            //                     "        messages=[\n",
            //                     "          {\n",
            //                     "            \"role\": \"system\",\n",
            //                     "            \"content\": system_prompt\n",
            //                     "          },\n",
            //                     "          {\n",
            //                     "            \"role\": \"user\",\n",
            //                     "            \"content\": user_input\n",
            //                     "          }\n",
            //                     "        ],\n",
            //                     "        temperature=temperature,\n",
            //                     "        max_tokens=max_tokens,\n",
            //                     "        top_p=top_p,\n",
            //                     "        frequency_penalty=frequency_penalty,\n",
            //                     "        presence_penalty=presence_penalty\n",
            //                     "      )\n",
            //                     "      return response.choices[0].message.content\n",
            //                     "\n",
            //                     "    elif openai_api_type == \"complete\":\n",
            //                     "\n",
            //                     "      response = openai_client.completions.create(\n",
            //                     "        model = openai_model,\n",
            //                     "        prompt = f\"{system_prompt}\\n{user_input}\",\n",
            //                     "        temperature=temperature,\n",
            //                     "        max_tokens=max_tokens,\n",
            //                     "        top_p=top_p,\n",
            //                     "        frequency_penalty=frequency_penalty,\n",
            //                     "        presence_penalty=presence_penalty\n",
            //                     "      )\n",
            //                     "      return response.choices[0].text\n",
            //                     "\n",
            //                     "    raise Exception(\"Invalid API type\")\n"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "U5_Ejf-VY9oJ"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "# If we run openai API consecutively multiple times it may fail thus, running the API again after some interval until max_attempts are reached\n",
            //                     "def error_wrapper(user_input: str):\n",
            //                     "    max_attempts = 3\n",
            //                     "    current_attempt = 1\n",
            //                     "    wait_time = 10 # in seconds\n",
            //                     "    while current_attempt <= max_attempts:\n",
            //                     "        try:\n",
            //                     "            response = get_openai_response(user_input)\n",
            //                     "            return response\n",
            //                     "        except Exception as e:\n",
            //                     "            print(\"Exception!!!\", e)\n",
            //                     "            current_attempt += 1\n",
            //                     "            if current_attempt <= max_attempts:\n",
            //                     "                time.sleep(wait_time)\n",
            //                     "            else:\n",
            //                     "                break\n",
            //                     "    return \"Timed out exception\""
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "colab": {
            //                         "base_uri": "https://localhost:8080/"
            //                     },
            //                     "id": "MjbQeU_Rj_zO",
            //                     "outputId": "7419be0b-0c15-4bde-b942-921fd89a9cfc"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "df[output_annotation_column] = df[\"merged\"].progress_apply(\n",
            //                     "    lambda x: error_wrapper(str(x)))"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "colab": {
            //                         "base_uri": "https://localhost:8080/",
            //                         "height": 206
            //                     },
            //                     "id": "U2ofCByjkL6K",
            //                     "outputId": "9615f2a1-a8b8-4cc2-82b5-9e1e59587a0f"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "df.head()"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "LIZjgCu7lhNP"
            //                 },
            //                 "outputs": [],
            //                 "source": [
            //                     "df.to_csv(annotated_data_path, index=False)"
            //                 ]
            //             },
            //             {
            //                 "cell_type": "code",
            //                 "execution_count": null,
            //                 "metadata": {
            //                     "id": "GKB1G2lemXI9"
            //                 },
            //                 "outputs": [],
            //                 "source": []
            //             }
            //         ],
            //         "metadata": {
            //             "colab": {
            //                 "provenance": []
            //             },
            //             "kernelspec": {
            //                 "display_name": "Python 3",
            //                 "name": "python3"
            //             },
            //             "language_info": {
            //                 "codemirror_mode": {
            //                     "name": "ipython",
            //                     "version": 3
            //                 },
            //                 "file_extension": ".py",
            //                 "mimetype": "text/x-python",
            //                 "name": "python",
            //                 "nbconvert_exporter": "python",
            //                 "pygments_lexer": "ipython3",
            //                 "version": "3.10.0"
            //             }
            //         },
            //         "nbformat": 4,
            //         "nbformat_minor": 0
            //     },
            //     "metadata": {
            //         "path": "workflow1/openai_annotation_workflow.ipynb",
            //         "steps": [
            //             {
            //                 "install_requiremets": {
            //                     "run_cell": [
            //                         0,
            //                         2
            //                     ],
            //                     "display_cell": [
            //                         0,
            //                         0
            //                     ]
            //                 }
            //             },
            //             {
            //                 "input_data": {
            //                     "run_cell": [
            //                         2,
            //                         3
            //                     ],
            //                     "display_cell": [
            //                         2,
            //                         2
            //                     ]
            //                 }
            //             },
            //             {
            //                 "hyperparameters": {
            //                     "run_cell": [
            //                         3,
            //                         5
            //                     ],
            //                     "display_cell": [
            //                         3,
            //                         5
            //                     ]
            //                 }
            //             },
            //             {
            //                 "annotate_data": {
            //                     "run_cell": [
            //                         5,
            //                         -1
            //                     ],
            //                     "display_cell": [
            //                         5,
            //                         5
            //                     ]
            //                 }
            //             }
            //         ]
            //     },
            //     "message": "Successful"
            // };
            // setworkflowData(data);
        } catch (error) {
            console.error(error)
        }
        finally { setIsloading(false) }
    }
    useEffect(() => {
        fetchWorkflow(workflowName)
    }, [])
    return (<>
        <WorkflowProvider initialData={workflowData}>
            <WorkflowComp workflowData={workflowData} isloading={isloading} workflowName={workflowName} />
            {/* <WorkFLowMainComp initialData={workflowData} /> */}
        </WorkflowProvider>
    </>
    )
}

export default Workflow;